import React from 'react';

/**
 * Client Portal Header component with LSAS branding
 * @param {Object} props - Component props
 * @param {Object} props.userInfo - User information object
 * @param {Function} props.onLogout - Logout handler function
 * @returns {React.ReactElement} ClientHeader component
 */
const ClientHeader = ({ userInfo, onLogout }) => {
  return (
    <header className="bg-brand-black shadow-lg">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="/assets/logo/logo-lsas-full.svg" 
                alt="Lone Star Aerial Solutions" 
                className="h-20 md:h-24 w-auto hover:opacity-80 transition-opacity"
              />
            </a>
            <div className="ml-6 border-l border-white/20 pl-6">
              <h1 className="text-xl md:text-2xl font-bold text-white">
                Client Portal
              </h1>
              <p className="text-sm text-ink/80">
                Secure access to your deliverables
              </p>
            </div>
          </div>

          {/* User Info & Logout */}
          <div className="flex items-center space-x-6">
            {userInfo && (
              <div className="text-right hidden sm:block">
                <p className="text-sm text-ink/60">Logged in as</p>
                <p className="text-sm font-medium text-white">{userInfo.email}</p>
                {userInfo.client_name && (
                  <p className="text-xs text-brand-blue-600 font-medium">
                    {userInfo.client_name}
                  </p>
                )}
              </div>
            )}
            
            <button
              onClick={onLogout}
              className="inline-flex items-center px-4 py-2 border border-white/20 shadow-sm text-sm font-medium rounded-md text-white bg-transparent hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue-600 transition-colors"
            >
              <span className="mr-2">🚪</span>
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ClientHeader;
